"use client";

import { ReactNode } from "react";
import { Studio } from "@prisma/client";
import { AttributionCapture } from "@/components/attribution-capture";
import { FacebookPixel } from "@/components/facebook-pixel";
import { GoogleAnalytics } from "@/components/google-analytics";
import { ModalProvider } from "@/components/modal/provider";
import { useMarketingConsent } from "@/lib/hooks/use-marketing-consent";
import { StudioProvider } from "@/lib/state/studio";

export function DomainProviders({
  children,
  facebookPixelId,
  googleAnalyticsMeasurementId,
  studio,
}: {
  children: ReactNode;
  facebookPixelId?: string;
  googleAnalyticsMeasurementId?: string;
  studio?: Studio | null;
}) {
  const { granted } = useMarketingConsent();
  return (
    <StudioProvider studio={studio}>
      {/* ModalProvider must sit inside Member/Studio providers so modal
          content (rendered as a sibling of children) can read those contexts. */}
      <ModalProvider>
        <AttributionCapture consentGranted={granted} />
        {facebookPixelId && (
          <FacebookPixel pixelId={facebookPixelId} consentGranted={granted} />
        )}
        {googleAnalyticsMeasurementId && (
          <GoogleAnalytics
            measurementId={googleAnalyticsMeasurementId}
            consentGranted={granted}
          />
        )}
        {children}
      </ModalProvider>
    </StudioProvider>
  );
}
